<template>
  <v-row no-gutters style="padding: 0 15px">
    <v-col cols="12">
      <div
        style="
          font-size: 28px;
          padding-left: 40px;
          padding-right: 40px;
          text-align: center;
          margin: 20px 0;
          color: #0581c6;
          font-weight: bold;
        "
      >
        {{ $t("components.PowerDataMainReport.title") }}
      </div>
      <div style="margin: 0 16px 20px 16px">
        <div>
          <span style="font-size: 17px; color: #0581c6">{{ $t("common.words.client") }}: </span
          ><span style="font-size: 16px">{{ tenant }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">{{ $t("common.labels.reportDate") }}: </span
          ><span style="font-size: 16px">{{ report_date }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">{{ $t("common.labels.reportTime") }}: </span
          ><span style="font-size: 16px">{{ report_time }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">{{ $t("common.words.recepients") }}: </span
          ><span style="font-size: 16px">{{ final_recepient }}</span>
          <span v-if="recipients_number" style="font-size: 12px; color: #0581c6">
            ...+{{ recipients_number }} {{ $t("common.words.more") }}</span
          >
        </div>
      </div>
    </v-col>
    <v-col cols="12">
      <div
        style="
          font-size: 24px;
          padding-left: 40px;
          padding-right: 40px;
          text-align: center;
          color: #0581c6;
          font-weight: bold;
        "
      >
        {{ $t("common.labels.reportAtGlance") }}:
        <div class="primaryGrey--text text-caption">({{ $t("common.times.time.last24Hours") }})</div>
      </div>
    </v-col>
    <v-col cols="12">
      <v-row no-gutters class="">
        <v-col cols="12" sm="6" class="d-flex">
          <v-card flat width="100%">
            <v-card-text style="padding: 0; background: #ffffff !important" class="pa-0">
              <RadialChartVT
                :v-if="this.overview_data && message_type_data"
                :title="page_content.capacity_problems.title"
                :chartData="message_type_data"
                print="true"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" class="d-flex">
          <v-card flat width="100%">
            <v-card-text style="padding: 0; background: #ffffff !important" class="pa-0">
              <RadialChartVT
                :v-if="this.overview_data && imbalance_problems"
                :title="page_content.imbalance_problems.title"
                :chartData="imbalance_problems"
                print="true"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" class="d-flex">
          <v-card flat width="100%">
            <v-card-text style="padding: 0; background: #ffffff !important" class="pa-0">
              <RadialChartVT
                :v-if="this.overview_data && power_change_problems"
                :title="page_content.power_change_problems.title"
                :chartData="power_change_problems"
                print="true"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="12">
              <v-card flat>
                <v-card-title style="font-size: 20px; color: #1b428b; background: #ffffff">
                  {{ $t("common.labels.fleetStatus") }}
                </v-card-title>
                <v-card-subtitle style="background: #ffffff"
                  ><b>{{ $t("common.labels.totalDevices") }}:</b>
                  {{ devices && devices.length > 0 ? devices.length : "-" }}</v-card-subtitle
                >
                <v-card-text>
                  <DataTableVT
                    v-if="issues_data"
                    :headers="config.issues_table"
                    :items_list="issues_data"
                    item_key="id"
                    no_pagination="true"
                    no_sort="true"
                    print="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card flat>
                <v-card-title style="font-size: 20px; color: #1b428b; background: #ffffff">
                  {{ $t("common.words.devices") }}
                </v-card-title>
                <v-card-subtitle style="background: #ffffff"
                  ><b>{{ $t("common.labels.fleetSize") }}:</b>
                  {{ devices && devices.length > 0 ? devices.length : "-" }}</v-card-subtitle
                >
                <v-card-text>
                  <DataTableVT
                    v-if="computed_devices"
                    sort_by="MaxUtilisation"
                    :headers="config.devices_table"
                    :items_list="computed_devices"
                    item_key="id"
                    no_sort="true"
                    no_pagination="true"
                    print="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import DataTableVT from "../components/DataTableVT";
import RadialChartVT from "../components/RadialChartVT";
import { axios_get } from "../services/vt_service";
import { trafo } from "../services/powerdata";
import { tracking } from "../services/tracking";
import { content } from "../../config/assets.js";
import { content as reports_config } from "../../config/powerdata_reports.js";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];

export default {
  name: "PowerDataMainReport",
  components: {
    DataTableVT,
    RadialChartVT,
  },
  props: {},
  watch: {},
  data: function () {
    return {
      tenant: "",
      recepient: "",
      report_date: "",
      report_time: "",
      snackbar: false,
      network_error: false,
      devices: null,
      search_term: "",
      error_message: "",
      total_assets: 0,
      total_assets_known: 0,
      total_assets_unknown: 0,
      perc_assets_known: 0,
      perc_assets_unknown: 0,
      value_missing_assets: 0,
      deviceId: null,
      dialog: false,
      message: "",
      overview_data: null,
      current_list: "all",
      location_data: {},
      recipients_list: null,
      config: null,
    };
  },
  created() {
    this.page_content = content;
    this.config = reports_config;
  },
  mounted() {
    if (this.$route.name == "Report_Snapshot") this.get_recipients_list();
    var d = new Date();
    var dd = String(d.getDate()).padStart(2, "0");
    var mm = String(d.getMonth() + 1).padStart(2, "0");
    var yyyy = d.getFullYear();
    var today = dd + "/" + mm + "/" + yyyy;
    this.tenant = this.$auth.user[tenant_key]["tenant"];
    this.recepient = this.$auth.user.email;
    this.report_date = today;
    this.report_time = d.getHours() + ":" + (d.getMinutes() < 10 ? "0" : "") + d.getMinutes() + ":" + d.getSeconds();
    this.get_device_list();
    // this.$store.commit("update_page_title", "Report");
    this.get_stats();
  },
  filters: {},
  methods: {
    async get_recipients_list() {
      this.network_error = false;
      let response = await axios_get(tracking.get_report_recipients_list, { id: 1 });
      this.recipients_list = response[0];
    },
    format_chart_data(chart_data, config) {
      var data = [];
      var others_total = 0;
      if (chart_data) {
        data = config.data.map((currentValue) => {
          others_total = 0;
          var total = 0;
          var result = chart_data.filter((data) => {
            total = total + data.Total;
            if (
              data.name &&
              !currentValue.values &&
              data.name.toLowerCase().trim() == currentValue.value.toLowerCase().trim()
            ) {
              return true;
            } else if (data.name && !currentValue.value && currentValue.values) {
              others_total =
                others_total +
                (data.name && currentValue.values.indexOf(data.name.toLowerCase()) == -1 ? data.Total : 0);
              return true;
            } else {
              return false;
            }
          });
          var value = result[0] && result[0]["Total"];
          var final_val = currentValue.label == "Others" ? others_total : value;
          return [
            currentValue.label,
            final_val,
            {
              msg: currentValue.msg,
              title: currentValue.label,
              footer: `${this.$numberWithCommas(final_val)}(${this.$numberWithCommas(
                Math.round((final_val / total) * 10000) / 100
              )}%)`,
            },
          ];
        });
      } else {
        data = [config.header];
      }
      return data ? [config.header, ...data] : null;
    },
    async get_stats() {
      this.network_error = false;
      let response = await axios_get(trafo.get_assets_overview, { duration: 1 });
      this.overview_data = response;
    },
    async get_device_list() {
      this.network_error = false;
      let response = await axios_get(trafo.get_assets_data, { num_days: 1 });
      this.devices = response;
      this.devices.sort((a, b) => b.MaxUtilisation - a.MaxUtilisation);
    },
    apply_graph_filter(val) {
      this.message = val ? "Filter Applied Successfully!" : "Filter Removed Successfully!";
      this.snackbar = true;
      let temp = val.split("(");
      this.current_list = temp[0];
    },
    open_details(deviceId) {
      this.deviceId = deviceId;
      this.dialog = true;
    },
    sort(s) {
      if (s === this.current_sort) {
        this.current_sort_dir = this.current_sort_dir === "asc" ? "desc" : "asc";
      }
      this.current_sort = s;
    },
  },
  computed: {
    message_type_data: function () {
      return this.overview_data
        ? this.format_chart_data(this.overview_data.capacityProblems, this.page_content.capacity_problems)
        : [];
    },
    imbalance_problems: function () {
      return this.overview_data
        ? this.format_chart_data(this.overview_data.imbalanceProblems, this.page_content.imbalance_problems)
        : [];
    },
    power_change_problems: function () {
      return this.overview_data
        ? this.format_chart_data(this.overview_data.powerChangeProblems, this.page_content.power_change_problems)
        : [];
    },
    user_account: function () {
      return this.$auth.user;
    },
    final_recepient: function () {
      if (this.$route.name == "Report_Snapshot") {
        if (this.recipients_list && this.recipients_list.length > 0) {
          let recepients = "";
          let total = this.recipients_list.length;
          let limit = total > 7 ? 7 : total;
          for (var i = 0; i < limit; i++) {
            recepients = recepients
              ? recepients + "; " + this.recipients_list[i]["RecipientEmail"]
              : this.recipients_list[i]["RecipientEmail"];
          }
          return recepients;
        }
        return this.recepient;
      }
      return this.recepient;
    },
    recipients_number: function () {
      if (this.$route.name == "Report_Snapshot") {
        if (this.recipients_list && this.recipients_list.length > 0) {
          let total = this.recipients_list.length;
          return total > 7 ? total - 7 : null;
        }
        return null;
      }
      return null;
    },
    computed_devices: function () {
      return this.devices ? this.devices.slice(0, 200) : null;
    },
    issues_data: function () {
      let temp = {
        HasMissedMessages: 0,
        HasImbalance: 0,
        HasCurrentOverLimit: 0,
        HasLowBattery: 0,
        HasNoPower: 0,
        HasTemperatureOutsideRange: 0,
        HasTemperatureOverLimit: 0,
        HasTemperatureSenseError: 0,
      };
      let data = [];
      if (this.devices && this.devices.length > 0) {
        this.devices.map((elem) => {
          Object.keys(temp).forEach((key) => {
            if (elem[key]) {
              temp[key] = temp[key] + 1;
            }
          });
        });
        Object.keys(temp).forEach((key) => {
          if (temp[key] != 0)
            data.push({
              issue: this.$config.issues[key].label,
              totalDevices: temp[key],
              percentageDevices: Math.round((temp[key] / this.devices.length) * 10000) / 100,
            });
        });
      }
      return data.length > 0 ? data : null;
    },
  },
};
</script>
